// *** Forgot Password Component ****
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ApiHelper } from "../helpers/ApiHelper";
import { API } from "../services/api";
import "../assets/css/forgotpswd.css";
import Validation from "../commonComponents/Validation";
import forgot from "../assets/img/synchronize 1.svg";
import emailimg from "../assets/img/emails 1.svg";
import sussecimg from "../assets/img/success 1.svg";

const PasswordReset = (props) => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [pswdError, setPswdError] = useState(false);
    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [resDataStatus, setResDataStatus] = useState(false);
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [messg, setMessg] = useState('');
    const [isStatus, SetStatus] = useState(false);
    const [otp, setOtp] = useState('');
    const [codeError, setCodeError] = useState(false);

    useEffect(() => {

        const mailId = JSON.parse(localStorage.getItem('emailForForgotPassword'));
        if (mailId) {
            setEmail(mailId)
        }
    }, [])
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        // Basic email validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsEmailValid(emailPattern.test(value));
        setEmailError(false);
        setResDataStatus(false);
        setError(false);

    };

    const handleGenerate = async () => {
        setLoader(true);
        if (email !== "") {
            setError(false)
            const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;
            const result = pattern.test(email);
            if (result === false) {
                setEmailError(true)
            }
            else {
                setEmailError(false)
                const formData = {
                    email: email,
                };
                await ApiHelper.post(API.forgotUserPassword, formData)
                    .then((resData) => {
                       

                        
                        if (resData.data.status) {
                            setMessg(resData.data.message);
                            SetStatus(resData.data.status)
                        }
                        else {
                            setResDataStatus(true)
                        }
                    })
                    .catch((err) => {
                        setLoader(false);
                        console.log(err, 'err');
                    });
            }
        }
        else {
            setLoader(false);
            setError(true);
        }
    }
    const handleOtpSubmit = async () => {
        if (otp !== "") {
            setError(false)
            const formData = {
                email: email,
                resettoken: otp
            }
            await ApiHelper.post(API.checkResetPasswordToken, formData)
                .then((resData) => {
                    

                    if (resData.data.status) {
                        navigate('/reset-password',{state : {userId: resData.data.user}})
                    }
                    else {
                        setCodeError(true);
                    }
                })
                .catch((err) => {
                    setLoader(false);
                    console.log(err, 'err');
                });
        }
        else {
            setError(true)
        }

    }
    const handleReset = async () => {
        setLoader(true);
        if ( password !== "" && confirmPassword !== "") {
            setError(false)
            if (password === confirmPassword) {
                setPswdError(false)
                const formData = {
                    userid: props.userid,
                    password: password
                };
                await ApiHelper.post(API.resetUserPassword, formData)
                    .then((resData) => {
                        if (resData.data.status) {
                            localStorage.setItem('emailForForgotPassword', JSON.stringify(""));
                            navigate('/password-reset')
                        }
                    })
                    .catch((err) => {
                        setLoader(false);
                        console.log(err, 'err');
                    });

            }
            else {
                setPswdError(true);
            }
        }
        else {
            setLoader(false);
            setError(true);
        }
    }

    function isValidPassword(pwd) {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(pwd);
    }

    return (
        <div className="mainpage forgot-page">
            <div class="container-fluid ">
                <div class="row justify-content-center">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div className="form-box shadow formboxwidth forgot-box">
                            <div class="forgot-imgs mx-auto mb-3">
                                {props.image === "forgot" ? <img src={forgot} className="forgot-icon" alt="Centered Image" /> :
                                    props.image === "reset" ? <img src={forgot} className="forgot-icon" alt="Centered Image" /> :
                                        props.image === "success" ? <img src={sussecimg} className="forgot-icon" alt="Centered Image" /> : null}
                            </div>

                            <h5 className="mb-4 freeaccount text-center">{props.title}</h5>

                            <p className="">
                                <span className="points-popuos"> {props.content}</span></p>

                            {props.image === "forgot" &&
                                <form>
                                    <div className="form-group email-verification">
                                        <input type="email" className="form-control" placeholder="Enter your email"
                                            autoComplete="off"
                                            autoCorrect="off"
                                            autoCapitalize="off"
                                            spellCheck="false"
                                            onChange={handleEmailChange} value={email} />

                                        <button type="button" disabled={!isEmailValid} className={isEmailValid ? 'verify-btn fpw active' : 'verify-btn fpw'} onClick={() => handleGenerate()}>Generate</button>
                                    </div>
                                    {emailError && <div style={{ marginTop: "-16px" }}><Validation message={'Please enter valid email'} /></div>}
                                    {email === "" && error ? (
                                        <div style={{ marginTop: "-16px" }}><Validation message={'Please enter email'} /></div>
                                    ) : null}
                                    {resDataStatus && email !== "" ? (
                                        <div style={{ marginTop: "-16px" }}><Validation message={'Email address not found.'} /></div>

                                    ) : null}
                                    {messg !== "" && !resDataStatus && <p className="paragraph-dh">{isStatus ? <i class="bi bi-check-circle-fill mr-2" style={{ color: "green" }}></i> :
                                        <i class="bi bi-x-circle-fill" style={{ color: "red" }}></i>}&nbsp;&nbsp;{messg}</p>}
                                    <div className="check-p mb-4" >
                                        {isStatus && <p className="paragraph-dh" >Please check your email to get the code. </p>}
                                    </div>
                                    <h4 className="code-hd text-center" >Enter Code</h4>
                                    <div className="form-group mb-4">
                                        <input type="text" placeholder="Enter your code" className="form-control"
                                            value={otp}
                                            onChange={(e) => { setOtp(e.target.value); setCodeError(false) }}></input>
                                        {otp === "" && error ? (
                                            <Validation message={'Please enter the generated code'} />
                                        ) : null}
                                        {otp !== "" && codeError ? (
                                            <Validation message={'Incorrect code.'} />
                                        ) : null}
                                    </div>
                                    <div className="">
                                        <button type="button" className="btn text-dark reset-btn" onClick={() => handleOtpSubmit()}>Reset Password</button>
                                    </div>
                                    <div className="">
                                        <button type="button" className="btn text-dark logbtn" onClick={() => navigate('/')} >Cancel</button>
                                    </div>


                                </form>}
                            
                            {props.image === "reset" &&
                                <form className="forgot-btn" >
                                    <div className="position-relative">
                                        <input type={showPassword ? "text" : "password"} className="form-control" placeholder="Enter your new password"
                                            autoComplete="off"
                                            autoCorrect="off"
                                            autoCapitalize="off"
                                            spellCheck="false"
                                            onChange={(e) => { setPassword(e.target.value) }} 
                                            value={password} />
                                        <i
                                            className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'} eye-icon password-icon`}
                                            onClick={() => setShowPassword(!showPassword)}
                                        ></i>
                                        
                                    </div>
                                    {password === "" && error ? (
                                            <div className="valmsg">
                                                <Validation message={'Please enter your new password'} />
                                            </div>
                                        ) : null}
                                         {(!isValidPassword(password))?(
                                            <div className="valmsg">
                                                <Validation message={'Password must include uppercase,lowercase,number,symbol and be at least 8 characters long'} />
                                            </div>
                                         ):null}
                                    <div className="position-relative">
                                        <input type={showPasswordConfirm ? "text" : "password"} className="form-control" placeholder="Re-enter New password"
                                            autoComplete="off"
                                            autoCorrect="off"
                                            autoCapitalize="off"
                                            spellCheck="false"
                                            onChange={(e) => { setConfirmPassword(e.target.value);setPswdError(false) }} value={confirmPassword} />
                                        <i
                                            className={`bi ${showPasswordConfirm ? 'bi-eye' : 'bi-eye-slash'} eye-icon password-icon`}
                                            onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                                        ></i>
                                       
                                    </div>
                                     {confirmPassword === "" && error ? (
                                            <Validation message={'Please re-enter your new password'} />
                                        ) : null}
                                        {confirmPassword !== "" && pswdError ? (
                                            <Validation message={'Password mismatch'} />
                                        ) : null}
                                    <div className=" mt-4">
                                        <button type="button" className="btn text-dark reset-btn" onClick={() => handleReset()}>Submit</button>
                                    </div>
                                    <div className="">
                                        <button type="button" className="btn text-dark logbtn" onClick={() => navigate('/')}>Cancel</button>
                                    </div>


                                </form>}
                            {props.image === "success" &&
                                <div className="">
                                    <button type="button" className="btn text-dark reset-btn" onClick={() => navigate('/')}>Login Now</button>
                                </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PasswordReset;
